export const environment = {
  production: true,
  releaseStage: "${ENVIRONMENT}",
  apiUrl: '${API_URL}',
  apiKey: '${API_KEY}',
  bugsnagApiKey: '${BUGSNAG_API_KEY}',
  API_URL: 'assets/config/app.config.json',
};
